import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class LoaderExternalFileService {

  static DPE_GES_LIB_PATH = 'assets/js/dpeges.js';

  public static loadDpeGesLib() {
    return LoaderExternalFileService.loadJSFile(LoaderExternalFileService.DPE_GES_LIB_PATH);
  }

  /**
   * In a standalone component you have to load the external lib
   * in the component (the component doesn't know out of his context)
   */
  public static loadJSFile(path: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = path;
      script.onload = () => {
        resolve();
      };
      script.onerror = (err) => {
        reject(err);
      }
      document.body.appendChild(script);
    });
  }
}
